module.exports = __webpack_public_path__ + "static/media/car-blue.9f2bdad1.png";